function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Order = function Order(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#242328",
    fillRule: "evenodd",
    d: "M4.13 4.08a2.25 2.25 0 0 1 2.25-2.25h10.98a2.25 2.25 0 0 1 2.25 2.25v17.5a.75.75 0 0 1-1.164.626l-1.916-1.267-1.917 1.267a.75.75 0 0 1-.827 0l-1.916-1.267-1.917 1.267a.75.75 0 0 1-.827 0L7.21 20.939l-1.917 1.267a.75.75 0 0 1-1.163-.626zm2.25-.75a.75.75 0 0 0-.75.75v16.105l1.166-.77a.75.75 0 0 1 .827 0L9.54 20.68l1.916-1.267a.75.75 0 0 1 .827 0l1.917 1.267 1.916-1.267a.75.75 0 0 1 .827 0l1.167.771V4.08a.75.75 0 0 0-.75-.75zm1.76 3.659a.75.75 0 0 1 .751-.749l5.99.01a.75.75 0 1 1-.002 1.5l-5.99-.01a.75.75 0 0 1-.75-.751m.74 3.341a.75.75 0 1 0 0 1.5h6a.75.75 0 0 0 0-1.5zm-.75 4.829a.75.75 0 0 1 .751-.749l5.99.01a.75.75 0 1 1-.002 1.5l-5.99-.01a.75.75 0 0 1-.75-.751",
    clipRule: "evenodd"
  }));
};
export default Order;
Order.displayName = 'Order';